// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2FtTp","title":"Images90_title__3rBXw","images":"Images90_images__2WKyB"};